var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6263 0.00275922 23.9972 5.37373 24 12C23.9961 18.6258 18.6258 23.9961 12 24C5.37395 23.9967 0.00331054 18.626 0 12C0 5.37258 5.37258 0 12 0ZM9.88566 18.3824C12.0686 18.3972 14.1665 17.5365 15.7101 15.9929C17.2538 14.4492 18.1144 12.3514 18.0997 10.1684C18.0997 10.0434 18.0997 9.9174 18.0927 9.7974C18.6588 9.38696 19.1474 8.87904 19.5357 8.2974C19.0082 8.53041 18.4491 8.68375 17.8767 8.7524C18.4808 8.39166 18.9325 7.82268 19.1467 7.1524C18.5794 7.48721 17.9597 7.72387 17.3137 7.8524C16.7682 7.26952 16.0049 6.93984 15.2067 6.9424C13.613 6.94295 12.3212 8.23473 12.3207 9.8284C12.3188 10.0501 12.345 10.2712 12.3987 10.4864C10.077 10.3709 7.91382 9.27406 6.44866 7.4694C6.19299 7.90954 6.05811 8.40939 6.05766 8.9184C6.05639 9.88401 6.54028 10.7857 7.34566 11.3184C6.88802 11.3061 6.4402 11.1829 6.04066 10.9594V10.9954C6.04095 12.3704 7.00997 13.5548 8.35766 13.8274C8.10986 13.8942 7.8543 13.9278 7.59766 13.9274C7.41464 13.9276 7.23207 13.9095 7.05266 13.8734C7.42846 15.05 8.51175 15.8566 9.74666 15.8794C8.72311 16.6802 7.46026 17.1141 6.16066 17.1114C5.93068 17.1125 5.70087 17.0988 5.47266 17.0704C6.78567 17.9234 8.31888 18.3752 9.88466 18.3704L9.88566 18.3824Z",
    fill: "#00ABE8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.629dc1d8d619b62da13e54306b322f1e.svg";
export { ForwardRef as ReactComponent };